import type { IngredientQL } from './graphql_generated/graphql';
import {
  InputBoardBasisQL as GraphQLInputBoardBasisQL,
  InputIngredientTypeQL,
  InputSelectedHotelTypesQL,
} from './graphql_generated/graphql';

export type IngredientTypeQL = InputIngredientTypeQL;
export const IngredientTypeQL = InputIngredientTypeQL;

export type SelectedHotelTypeQL = InputSelectedHotelTypesQL;
export const SelectedHotelTypeQL = InputSelectedHotelTypesQL;

export type InputBoardBasisQL = GraphQLInputBoardBasisQL;
export const InputBoardBasisQL = GraphQLInputBoardBasisQL;

export type HotelConstraintSelectionQL = Pick<
  IngredientQL,
  | 'serializedConstraint'
  | 'destination'
  | 'polygon'
  | 'hotelCodes'
  | 'tagId'
  | 'polygonId'
  | 'polygonIds'
  | 'destinationCode'
>;

export type HotelConstraintQL = HotelConstraintSelectionQL &
  Pick<
    IngredientQL,
    | 'starRating'
    | 'freeCancellation'
    | 'boardBasis'
    | 'petsAreAllowed'
    | 'isBusinessProperty'
    | 'isFamilyProperty'
    | 'isGreenSustainableProperty'
    | 'hasParking'
    | 'hasPool'
    | 'hasSpa'
    | 'hasGym'
    | 'hasInternet'
    | 'hasAirConditioning'
    | 'hasElectricVehicleChargingStation'
    | 'maxNumberOfHotels'
    | 'selectedHotelTypes'
    | 'hotelName'
    | 'polygonIds'
  >;
